/**
 * Created by manoraj.k on 17/08/17.
 */
export const colors = {
    brandBlue: "#027CD5",
    darkGrey: "#484848",
    greyText: "#909090",
    greyBorder: "#EAEAEA",
    selectedBlue: "rgba(206,229,246,0.5)",
    greyBackground: "#FAFAFA",
    blueBackground: "#e6f2fb",
    lineBorder: "#DBDBDB",
    btnBorder: "#027CD5",
    titleBlack: "#2A2C2E",
    whiteText: "#FFFFFF",
    greyTableHeaderText: "#717171",
    echoBlueBackground: "#E8ECF1",
    success: "#5abf6d",
    failure: "#FC4549",
    headingColor: "#3F3F3F",
    activeMenu: "#D9ECF9",
    inputBorder: "#CCCCCC",
    navButtonText: "#848482",
    modalFooterShadow: "0px -7px 10px -8px rgba(0,0,0,0.15)",
    modalShadow: "rgba(0, 0, 0, 0.24) 7px 6px 12px -7px",
    modalHeaderBorderColor: "#e8e8e8",
    modalBorderColor: "#f7f7f7",
    activeBreadCrumbColor: "#337ab7",
    loaderColor: "#42abff",
    blackText: "#000000",
    treeMenuItemBorderColor: "#F1F2F4",
    categoryTobeSelectedColor : "#AEAEAE",
    searchInputTextColor : "#ADADAD",
    statusIconColor : "#A2A2A2",
    statusHeadingColor : "#F5F5F5",
    chipBgColor : "#F2F2F2",
    brandListingBackground : "#F8F8F8",
    datePickerBorderColor: '#4badff',
    datePickerBgColor: '#4bc1ff',
    linkIcon: "#3B7ADB",
    successIcon: "#45B95A",
    failureIcon: '#F86D72',
    warningIcon: '#FF9F00',
    inprogressIcon: '#97A8BE',
    wizardBorder: '#DFDFDF',
    breadcrumbColor: '#9B9B9B',
    breadcrumbShadow: '#d0d0d0',
    nobelHeader: '#9B9B9B',
    whiteSmoke: '#DFDFDF',
    chipBackground: '#c8c8c8',
    greyBtnBackground: '#9B9B9B',
    bluishGreyText: '#86a0b5',
    accordianBorderColor: '#f2f3f4'
};

export default colors;
